import { Typography } from "@material-ui/core";
import React from "react";
import { useParams } from "react-router-dom";
import useCurrentUser from "../../hooks/useCurrentUser";
import useEarningHistory from "../../hooks/useEarningHistory";
import "./history.css";
function UserHistory() {
  const { userId } = useParams();
  const { user, loading: currentUserLoading } = useCurrentUser(userId);
  const { earningHistoryList } = useEarningHistory(userId);
  return (
    <div className="history_container">
      <center>
        <h3>Name: {user?.name}</h3>
        <h4>Email: {user?.email}</h4>
        <h4>
          Balance:<span style={{ color: "green" }}> {user?.balance}</span>
        </h4>{" "}
        <h4>
          Refer Earn:<span style={{ color: "green" }}> {user?.referEarn}</span>
        </h4>{" "}
        <h4>
          Refer User:<span style={{ color: "green" }}> {user?.referUser}</span>
        </h4>{" "}
        <h4>
          Total Earn :<span style={{ color: "green" }}> {user?.totalEarn}</span>
        </h4>
        <h4>
          Total Job Views :
          <span style={{ color: "green" }}> {user?.totalJobViews}</span>
        </h4>
        <h4>
          Refer Code :
          <span style={{ color: "green" }}> {user?.myReferCode}</span>
        </h4>
        <h4>
          Add Click :<span style={{ color: "green" }}> {user?.addClick}</span>
        </h4>
      </center>
      <br />
      <hr />
      <Typography variant="h4">Earning History: </Typography>
      <div className="table-responsive table-bordered ">
        <table
          style={{ width: "100%" }}
          className="table  table-striped table-bordered"
        >
          <thead
            className="text-center"
            style={{ backgroundColor: `green`, color: `#fff` }}
          >
            <th>Sl</th>
            <th>Amount</th>
            <th>Earn Form</th>
            <th>Time</th>
          </thead>
          <tbody className="text-left">
            {earningHistoryList?.map((data, index) => (
              <tr>
                <td>{index + 1}</td>

                <td>
                  <span style={{ color: "red" }}>{data?.amount}</span>
                </td>
                <td>{data?.earnForm}</td>
                <td>{data?.time}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UserHistory;
